export default {
    send_commands_title: "Enviar comando",
    send_commands_the_device_has_not_been_found: "No se ha encontrado el dispositivo",
    send_commands_the_device_has_already_been_added: "El dispositivo ya ha sido añadido",
    send_commands_the_unit_type_of_the_device_must_bet_the_same: "El tipo de unidad de los dispositivos debe ser el mismo",
    send_commands_the_manufacturer_of_the_devices_must_be_the_same: "El fabricante de los dispositivos debe ser el mismo",
    send_commands_imei_or_serial: "IMEI o Serial",
    send_commands_imei: "IMEI",
    send_commands_serial: "Serial",
    send_commands_model: "Modelo",
    send_commands_commands_sent: "Comandos enviados",
    send_commands_status: "Estado",
    send_commands_complete: "Completado",
    send_commands_send_more_commands: "Enviar más comandos",
    send_commands_mass_sms_title: "SMS Masivos",
    send_commands_send: "Enviar",
    send_commands_command_to_send: "Comando a Enviar",
    send_commands_canned_commands: "Comandos",
    send_commands_phone_numbers: "Números de Teléfono",
    send_commands_unit_type: "Tipo de Unidad",
    send_commands_unit_types: "Tipos de Unidad",
    send_commands_device_models: "Modelos de Dispositivo",
    send_commands_manufacturer_commands: "Comandos de Fabricante",
    send_commands_unit_type_commands: "Comandos de Tipo de Unidad",
    send_commands_device_model_commands: "Comandos de Modelo de Dispositivo",
    send_commands_error_phone_length: "El número de teléfono no tiene entre 10 y 15 digitos",
    send_commands_error_phone_not_number: "El número de teléfono no es un numero valido",
    send_commands_send_type: "Integración",
    send_commands_unvalid_phone_numbers: "No hay números de teléfonos validos para el enviar el comando",
    send_commands_errors: "Errores",
    send_commands_sent: "Comando enviado a",
    send_commands_error_duplicate_phone: "Número de teléfono duplicado",
    send_commands_error_iccid_length: "La longitud del ICCID no está entre 10 y 20 dígitos",
    send_commands_unvalid_iccid_numbers: "No hay ICCID's válidos para enviar el comando",
    send_commands_error_duplicate_iccid: "ICCID duplicado",
    send_commands_sms_activity: "Actividad SMS",
    send_commands_update_sms_activity: "Actualizar actividad SMS",
    send_commands_inbound: "Entrante",
    send_commands_outbound: "Saliente",
    send_commands_inbound_collapsed: "E",
    send_commands_outbound_collapsed: "S",
    send_commands_manufacturer: "Frabricante",
    send_commands_click_to_copy: "Clic para copiar",
    send_commands_only_for_m2md: "El envío de comandos HTTP solo está disponible para dispositivos M2MD",
    send_commands_http_validate_selection: "Seleccione el comando Localizar para configurar las opciones de localización HTTP",
    send_commands_canned_accuracy: "Precisión",
    send_commands_canned_skip_wifi_on: "Omitir WiFi Activado",
    send_commands_canned_skip_gps_on: "Omitir GPS Activado",
    send_commands_canned_skip_wifi_off: "Omitir WiFi Desactivado",
    send_commands_canned_skip_gps_off: "Omitir GPS Desactivado",
    send_commands_canned_accuracy_maximum_value_500: "El valor máximo para Precisión es 500",
    send_commands_canned_accuracy_minimum_value_1: "El valor mínimo para Precisión es 1",
}